// Client-side IP detection
//
// Based on https://extreme-ip-lookup.com/
// Other possibile db: http://ip-api.com/json, https://ipinfo.io/, https://geoip-db.com

function checkIp(field_id) {
    if (!field_id) field_id = "osobni-udaje";
    const field = document.getElementById(field_id);

    var eventListenerFn = function() {
        ipLookup();
    }
    field.addEventListener('input', eventListenerFn, {once: true});
};